<ion-header>
  <ion-toolbar>
    <ion-title>Tipo de suscripción</ion-title>
    <ion-buttons slot="start">
      <ion-back-button
        defaultHref="/tecservice-transportec/subscription/subscribe-radial-options"
        color="primary"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card
    *ngFor="let sOption of subscriptionOptions"
    (click)="presentAlertConfirm(sOption)"
    [class.selected]="mySubscription && mySubscription.name === sOption.name && mySubscription.type === sOption.type"
  >
    <ion-grid>
      <ion-row>
        <ion-col size="3">
          <div [class]="'subscription-icon '+sOption.name.toLowerCase()">
            <ion-icon
              [src]="'/assets/icon/'+sOption.name.toLowerCase()+'.svg'"
              [style.transform]="sOption.type==='return' ? 'scaleX(-1)':''"
            ></ion-icon>
          </div>
        </ion-col>
        <ion-col size="9">
          <p *ngIf="sOption.name.toLowerCase()==='sr'">Redondo Fijo</p>
          <p *ngIf="sOption.name.toLowerCase()==='srf'">Redondo Flexible</p>
          <p *ngIf="sOption.name.toLowerCase()==='ss' && sOption.type === 'go' ">Sencillo Fijo Llegada</p>
          <p *ngIf="sOption.name.toLowerCase()==='ss' && sOption.type === 'return' ">Sencillo Fijo Salida</p>
          <p *ngIf="sOption.name.toLowerCase()==='ssf' && sOption.type === 'go' ">Sencillo Flexible Llegada</p>
          <p *ngIf="sOption.name.toLowerCase()==='ssf' && sOption.type === 'return' ">Sencillo Flexible Salida</p>
          <ion-icon button (click)="showInfo(sOption)" class="info-button" name="information-circle-outline"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-content>

<ion-footer class="ion-padding">
  <ion-button
    shape="round"
    fill="outline"
    color="primary"
    expand="block"
    [disabled]="!mySubscription"
    (click)="goSuscription()"
  >
    Siguiente
  </ion-button>
</ion-footer>
